import { Typography as MuiTypography, TypographyProps } from '@mui/material';

export const Typography = ({ children, ...otherProps }: TypographyProps) => {
  return <MuiTypography {...otherProps}>{children}</MuiTypography>;
};
